export enum PipelineLevel {
  Agent = 0,
  Team = 1,
  OSM = 2,
  HoB = 3,
  Director = 4,
}
